import { useContext, useEffect, useState } from "react"
import ReactDatePicker from "react-datepicker";
import { ApiGetCall, ApiGetCallAuthKey } from "../../JS/Connector";
import { formatDateToUsaMMDDYYYY, GetAllSchoolsByLocation, HideLoder, LogInUserID, MMDDYYYY, origin, ShowLoder } from "../../JS/Common";
import { TicketBySchool } from "./TicketBySchool";
import AveragePart from "./AveragePart";
import ReworkReport from "./ReworkReport";
import ReworkByTechnician from "./ReworkByTechnician";
import { UserContext } from "../../App";
import { useSelector } from "react-redux";
import { hasRoleAccess, RoleEnum } from "../../JS/RoleType";
import useConfig from "../../Hooks/useConfig";

export function ReportsIndex() {
    const userTimeZone = useSelector(
        state => state?.authData?.UserTimeZone || "America/New_York"
    );
    const { organization, adminCallNode } = useConfig();
    const today = new Date(
        new Date().toLocaleString("en-US", { timeZone: userTimeZone })
    );

    const oneMonthAgo = new Date(today);

    oneMonthAgo.setDate(1);
    oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

    const day = today.getDate();

    const lastDayOfPreviousMonth = new Date(
        oneMonthAgo.getFullYear(),
        oneMonthAgo.getMonth() + 1,
        0
    ).getDate();

    oneMonthAgo.setDate(
        Math.min(day, lastDayOfPreviousMonth)
    );
    const [Locations, setLocations] = useState([]);
    const [Schools, setSchools] = useState([]);
    const [LocationValue, setLocationValue] = useState('');
    const [SchoolValue, setSchoolValue] = useState('');
    const [loading, setLoading] = useState(false);
    const { UserData } = useContext(UserContext);
    const [allData, setAllData] = useState({
        TicketSchool: [],
        AveragePart: [],
        ReworkTickets: []
    })
    const [startDate, setStartDate] = useState(oneMonthAgo);
    const [endDate, setEndDate] = useState(today);
    const [SchoolFilterData, setSchoolFilterData] = useState([]);
    const [TechnicianPerformance, setTechnicianPerformance] = useState([]);
    const effectiveRole = UserData.copyrole || UserData.role || null;
    useEffect(() => {
        GetReports(startDate, endDate, null, null);
        GetTechnicianReports(startDate, endDate, null, null);

        if (hasRoleAccess(effectiveRole, RoleEnum.ONLY_VAR)) {
            ApiGetCall(`/schools/vendor-schools?vendorId=${LogInUserID}`).then((result) => {
                if (result == undefined || result == "") {
                    alert("Something went wrong");
                } else {
                    const responseRs = JSON.parse(result);
                    const sortedLocations = responseRs?.allLocation
                        ?.filter(location => location?.locationName && location?.locationName?.trim() != "")
                        ?.sort((a, b) => a?.locationName?.localeCompare(b?.locationName));

                    const sortedSchools = responseRs?.allSchool
                        ?.filter(location => location?.name && location?.name?.trim() != "")
                        ?.sort((a, b) => a?.name?.localeCompare(b?.name));

                    setLocations(sortedLocations)
                    setSchoolFilterData(sortedSchools)
                    setSchools(sortedSchools)
                }
            });
        } else {
            GetAllSchoolsByLocation({ setLocations, setSchoolFilterData, setAllSchool: setSchools });
        }
    }, []);
    async function GetReports(sdate, edate, locationid, schoolid) {
        setLoading(true);
        if (locationid == 0) {
            locationid = null;
        }
        if (schoolid == 0) {
            schoolid = null;
        }
        await ApiGetCall(`${adminCallNode}/reports/side?startDate=${formatDateToUsaMMDDYYYY(sdate)}&endDate=${formatDateToUsaMMDDYYYY(edate)}&locationId=${locationid}&schoolId=${schoolid}&userId=${LogInUserID}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                if (responseRs.status == "success") {
                    setAllData({
                        ...allData, TicketSchool: responseRs.ticketbyschool, AveragePart: responseRs.parts_avrg, ReworkTickets: responseRs.reworkticketbyschool
                    })
                }
                setLoading(false);
            }
        });
    }
    async function GetTechnicianReports(sdate, edate, locationid, schoolid) {
        setLoading(true);
        if (locationid == 0) {
            locationid = null;
        }
        if (schoolid == 0) {
            schoolid = null;
        }
        await ApiGetCall(`/reports/technician-rework-performance?startDate=${formatDateToUsaMMDDYYYY(sdate)}&endDate=${formatDateToUsaMMDDYYYY(edate)}&locationId=${locationid}&schoolId=${schoolid}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                setTechnicianPerformance(responseRs.technician_performance)
                setLoading(false);
            }
        });
    }
    function handleStartDateChange(date) {
        setStartDate(date);
        GetReports(date, endDate, LocationValue, SchoolValue);
        GetTechnicianReports(date, endDate, LocationValue, SchoolValue);
    };
    function handleEndDateChange(date) {
        setEndDate(date);
        GetReports(startDate, date, LocationValue, SchoolValue);
        GetTechnicianReports(startDate, date, LocationValue, SchoolValue);
    };
    const handleLocationValue = (val) => {
        setLocationValue(val);
        if (val == "0") {
            setSchoolFilterData(Schools);
            setSchoolValue('0');
            GetReports(startDate, endDate, val, null);
            GetTechnicianReports(startDate, endDate, val, 0);
        } else {
            var filterSchoolByLocation = Locations?.filter((data) => data?.id == val);
            setSchoolFilterData(filterSchoolByLocation[0]?.school?.slice()?.sort((a, b) => a.name.localeCompare(b.name)));
            setSchoolValue('0');
            GetReports(startDate, endDate, val, 0);
            GetTechnicianReports(startDate, endDate, val, 0);
        }

    }
    return (
        <>
            {loading ? <ShowLoder /> : <HideLoder />}
            <div className='row col-12 pe-0 align-items-center pb-3'>
                <div className='col-md-4'>
                    <h1 className="PageHeading">Reports</h1>
                </div>
                <div className="col-md-4 text-end row px-0">
                    <div className="col-md-6 d-flex  align-items-center py-2 px-0">
                        <label className="px-3"></label>
                        <ReactDatePicker
                            className="form-control me-4 text-center"
                            selected={startDate}
                            onChange={(e) => { handleStartDateChange(e); }}
                            dateFormat="MM/dd/yyyy"
                            maxDate={today}
                        />
                    </div>
                    <div className="col-md-6 d-flex  align-items-center py-2 px-0">
                        <label className="px-3">To</label>
                        <ReactDatePicker
                            className="form-control me-4 text-center"
                            selected={endDate}
                            onChange={(e) => { handleEndDateChange(e); }}
                            dateFormat="MM/dd/yyyy"
                            maxDate={today}
                        />
                    </div>
                </div>
                <div className="col-md-2 ms-2 py-1 pe-0">
                    <select value={LocationValue} onChange={(e) => { handleLocationValue(e.target.value); }}>
                        <option value="0">Filter by Location</option>
                        {Locations?.map((locationItem, j) => (
                            <option value={locationItem.id} key={j}>
                                {locationItem.location_name}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="col-md-2 ms-2 py-1 pe-0">
                    <select value={SchoolValue} onChange={(e) => { setSchoolValue(e.target.value); GetReports(startDate, endDate, LocationValue, e.target.value); GetTechnicianReports(startDate, endDate, LocationValue, e.target.value) }}>
                        <option value="0">Filter by {organization}</option>
                        {SchoolFilterData?.length == 0 && <optgroup label={`No ${organization} found`}></optgroup>}
                        {SchoolFilterData?.map((item, j) => (
                            <option value={item.id} key={j}>
                                {item.name}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
            <div className='GridBox px-3'>
                <div className="row p-3">
                    <div className="col-12 p-2">
                        <AveragePart schooldata={allData.AveragePart} />
                    </div>
                    <div className="col-12 p-2">
                        <TicketBySchool schooldata={allData.TicketSchool} />
                    </div>
                    {hasRoleAccess(effectiveRole, RoleEnum.EXCLUDE_VAR) &&
                        <>
                            <div className="col-12 p-2">
                                <ReworkReport schooldata={allData.ReworkTickets}
                                    startDate={startDate} endDate={endDate} LocationValue={LocationValue} SchoolValue={SchoolValue} />
                            </div>
                            <div className="col-12 p-2">
                                <ReworkByTechnician TechnicianPerformance={TechnicianPerformance} />
                            </div>
                        </>
                    }
                </div>
            </div>
        </>
    )
}
